/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./twinTableIconColumn.vue?vue&type=template&id=5d4b3986"
import script from "./twinTableIconColumn.vue?vue&type=script&lang=js"
export * from "./twinTableIconColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports